import { createReducer } from '@reduxjs/toolkit'

import { UserRole } from '@/types'
import {
  userLoginFailed,
  userLoginRequest,
  userLoginSuccess,
  userLoginWithTokenRequest,
  userLogout
} from './actions'

interface ILoginState {
  isAuthenticated: boolean
  loading: boolean
  userRoles: UserRole[]
  username: string
}

const initialState: ILoginState = {
  isAuthenticated: false,
  loading: false,
  userRoles: [],
  username: ''
}

const userAuthReducer = createReducer(initialState, builder => {
  builder
    .addCase(userLoginRequest, state => {
      state.isAuthenticated = false
      state.loading = true
    })
    .addCase(userLoginWithTokenRequest, state => {
      state.isAuthenticated = false
      state.loading = true
    })
    .addCase(userLoginSuccess, (state, action) => {
      state.isAuthenticated = true
      state.loading = false
      state.userRoles = action.payload.userRoles
      state.username = action.payload.username
    })
    .addCase(userLoginFailed, state => {
      state.isAuthenticated = false
      state.loading = false
      state.userRoles = []
      state.username = ''
    })
    .addCase(userLogout, state => {
      state.isAuthenticated = false
      state.loading = false
      state.userRoles = []
      state.username = ''
    })
})

export default userAuthReducer
